import { BarChart2 } from "lucide-react";
import { LucideProps } from "lucide-react";

interface ChartIconProps extends LucideProps {
  className?: string;
}

export default function ChartIcon({ className = "", size = 24, ...props }: ChartIconProps) {
  return <BarChart2 className={className} size={size} {...props} />;
}
